import { Component,EventEmitter,Input, Output } from '@angular/core';
import { AppService } from 'src/services/app.service';

/**
* @ignore - do not show in documentation
*/
@Component({
    selector:    'v-qr-dialog',
    templateUrl: './v-qr-dialog.component.haml',
    styleUrls:   ['./v-qr-dialog.component.sass'],
    standalone:  false
})
export class VQrDialogComponent{
    @Input() title: string;
    private _isVisible: boolean = false;
    public get isVisible(): boolean {
        return this._isVisible;
    }
    @Input() public set isVisible(value: boolean) {
        if (this._isVisible === value) return;
        this._isVisible = value;
        if (!value)
            this.onWantToClose(undefined);
    }
    @Input() isModal: boolean = true;

    @Input() qrdata: string = '';

    @Output() wantToClose = new EventEmitter();

    constructor(appService: AppService){}

    copyLink() {
        navigator.clipboard.writeText(this.qrdata).catch(e => console.error(e));
    }

    onWantToClose(event: PointerEvent | MouseEvent){
        this.wantToClose.emit(event);
    }
}
